module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/71655cde34ae75f48cb8820abf4b31e7.svg";